// extracted by mini-css-extract-plugin
export default {"container":"_2Sn1l","share-icons":"_3wSrn","shareIcons":"_3wSrn","share-icon":"_1yFOX","shareIcon":"_1yFOX"};